// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".animate-scroll-text{display:flex;overflow:hidden;width:100%}.animate-scroll-text_inner{font-size:15vw;padding:0 2.25ch;white-space:nowrap}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
